import gql from "graphql-tag";

// Shared fields returned for a library quote. getCMZLibraryQuotes forces
//   source = CMZ_LIBRARY on the backend, so we never pass source ourselves.
export const GET_CMZ_LIBRARY_QUOTES = gql`
  query GetCMZLibraryQuotes($filter: IslamicQuoteFilterInput) {
    getCMZLibraryQuotes(filter: $filter) {
      quotes {
        id
        source
        category
        arabicText
        translation
        transliteration
        reference
        surahNumber
        ayahNumber
        tags
        labels
        createdBy
        isVerified
        isActive
        createdAt
        updatedAt
      }
      totalCount
      hasMore
    }
  }
`;

export const GET_ISLAMIC_QUOTE_BY_ID = gql`
  query GetIslamicQuoteById($id: ID!) {
    getIslamicQuoteById(id: $id) {
      id
      source
      category
      arabicText
      translation
      transliteration
      reference
      surahNumber
      ayahNumber
      tags
      labels
      createdBy
      isVerified
      isActive
      createdAt
      updatedAt
    }
  }
`;

// Super-Admin calendar of scheduled Quote-of-the-Day broadcasts across a date
//   range (dates are plain "YYYY-MM-DD" strings, compared lexicographically).
export const GET_SCHEDULED_QOTD = gql`
  query GetScheduledQuotesOfTheDay($startDate: String!, $endDate: String!) {
    getScheduledQuotesOfTheDay(startDate: $startDate, endDate: $endDate) {
      id
      date
      quoteId
      isGlobal
      quote {
        id
        category
        arabicText
        translation
        reference
        surahNumber
        ayahNumber
        tags
        labels
        isVerified
        isActive
      }
    }
  }
`;
